import { styled } from "@mui/material/styles";
import { Dialog, Typography, Paper } from "@mui/material";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  zIndex: theme.zIndex.loadingModal,
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  "&.MuiPaper-root": {
    overflowY: "initial",
    padding: "20px 24px",
    width: 271,
    borderRadius: 10,
    boxShadow: "0 3px 6px 0 rgba(0,0,0,.25)",
    position: "relative",
    [theme.breakpoints.up("mobile")]: {
      width: 406,
      padding: "30px 40px",
      borderRadius: 20,
    },
  },
}));

export const Image = styled("img")({
  width: "100%",
});

export const ModalMessage = styled("div")({
  margin: "35px auto 20px auto",
  textAlign: "center",
});

export const Message = styled(Typography)({
  marginBottom: 20,
});
